<template>
    <div>
      <loading :active="isLoading" :is-full-page="true"></loading>
      <nav-header :title="title"></nav-header>
      <div class="center ">
        <Popper>
          <i style="color: #1f7aaf" class="material-icons md-48"> info </i>
          <template #content>
            <div
              style="min-width: 350px"
              class="alert alert-secondary"
              role="alert"
            >
              <div
                style="overflow: auto; max-height: 300px"
                v-html="mapDescription"
              ></div>
            </div>
          </template>
        </Popper>
      </div>
      <div class="toggle-wrapper ">
          <button class="btn btn-secondary btn-sm" @click="toggleTimeRange">
            {{ showLast30Days ? ($englishPreferred ? 'Show all' : 'Vis alle') : ($englishPreferred ? '30 days' : '30 dage') }}
          </button>
        </div>
      
      <div class="text-center" id="confirm-map-position-div">
        <div id="map" class="map"></div>
      </div>
  
      <div class="bottom-position-wrapper">
  <button
    @click="getLocation()"
    type="button"
    class="btn btn-primary fixed-button"
  >
    <i class="material-icons button-material-icon"> gps_fixed </i>
    {{ $englishPreferred ? "My position" : "Min placering" }}
  </button>
</div>

    </div>
  </template>
  
  <script>
  import "leaflet/dist/leaflet.css";
  import NavHeader from "../components/navbars/NavHeader.vue";
  import atlasSquareRepository from "../idb/repositories/atlasSquareRepository";
  import countPointsRepository from "../idb/repositories/countPointsRepository";
  import atlasSquarePointRepository from "../idb/repositories/atlasSquarePointRepository";
  import finnSiteRepository from "../idb/repositories/finnSiteRepository";
  import leaflet from "leaflet";
  import proj4 from "proj4";
  import Popper from "vue3-popper";
  import axios from "axios";
  import wkt from "wkt";
  import { toRaw } from "vue";
  // Import component
  import Loading from "vue3-loading-overlay";
  // Import stylesheet
  import "vue3-loading-overlay/dist/vue3-loading-overlay.css";
  delete leaflet.Icon.Default.prototype._getIconUrl;
  leaflet.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  });
  
  const atlasSquarePolygonGroup = null;
  
  export default {
    components: {
      NavHeader,
      Popper,
      Loading,
    },
    data() {
      return {
        title: this.$englishPreferred ? "Coverage map" : "Dækningskort",
        map: null,
        atlasSquares: [],
        atlasSquarePoints: [],
        countPoints: [],
        isMapColorFilled: true,
        isMapShowingPoints: false,
        baseLayers: null,
        lastZoom: 7,
        finnSites: [],
        gpsMarker: null,
        collectionMarkersLayer: null,
        fillOpacity: 0.4,
        mapDescription: "Orange polygoner angiver FiNN-områderne. Din tælling skal foregå inden<br>for områdeafgrænsningen.<br><br>Blå polygoner angiver de såkaldte test-områder, hvor der udover FiNN-tællinger<br>foregår andre optællingsmetoder. Du kan læse mere om de to områdetyper på<br>projektsiden. <br><br>Ved tryk på et FiNN-område fremkommer orange eller blå prikker - det er tidligere tællinger fra dig selv og andre brugere. Du kan skifte visning mellem tællinger fra de sidste 30 dage og tællinger foretaget siden projektets begyndelse. Skiftningen sker v. knappen ude på FiNN-kortet. Visningen af forhenværende tællinger skal hjælpe dig med at fordele tællingerne jævnt i FiNN-områderne.<br><br> God tællelyst!",
        ortoPreferred: false,
        isLoading: false,
        showLast30Days: true,
      };
    },
    methods: {
      toggleTimeRange() {
        // Toggle time range
        this.showLast30Days = !this.showLast30Days;

        // Clear current collection markers from map
        if (this.collectionMarkersLayer) {
          this.map.removeLayer(this.collectionMarkersLayer);
          this.collectionMarkersLayer = null;
        }
      },
      createMap() {
        this.map = leaflet.map("map").setView([55.939, 10.515], 7);
        let openStreetMap = leaflet.tileLayer(
          "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          {
            attribution:
              '<small><a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://www.openstreetmap.org/copyright">CC-BY-SA</a></small>',
            maxZoom: 18,
            id: "openstreetmap",
          }
        );
  
        let ortofotoLayer = leaflet.tileLayer.wms(
          "https://service.dofbasen.dk/geoserver/dof/wms",
          {
            layers: "dof:orto_foraar_wms",
            format: "image/png",
            attribution:
              '&copy; <a target="_blank" href="https://download.kortforsyningen.dk/content/vilk%C3%A5r-og-betingelser">Styrelsen for Dataforsyning og Effektivisering',
          }
        );
  
        let baseLayers = {
          "Datafordeler Ortofoto": ortofotoLayer,
          OpenStreetMap: openStreetMap,
        };
  
        // Add layer control to map
        this.baseLayers = leaflet.control
          .layers(baseLayers)
          .addTo(toRaw(this.map));
  
        leaflet.control.scale({ imperial: false }).addTo(toRaw(this.map));
  
        this.map.on("moveend", (e) => {
          this.mapMoveend();
        });
  
        this.map.on("click", (e) => {
          this.map.dragging.disable();
          this.map.doubleClickZoom.disable();
          this.map.scrollWheelZoom.disable();
          this.map.flyTo([e.latlng.lat, e.latlng.lng], 14);
          this.map.dragging.enable();
          this.map.doubleClickZoom.enable();
          this.map.scrollWheelZoom.enable();
        });
  
        if (this.ortoPreferred == true) {
          ortofotoLayer.addTo(toRaw(this.map));
        } else {
          openStreetMap.addTo(toRaw(this.map));
        }
      },
      drawFinnSitesOnMap() {
  if (!this.map) return;

  const sortedSites = [...this.finnSites].sort((a, b) =>
    a.isTestSite === b.isTestSite ? 0 : a.isTestSite ? 1 : -1
  );

  sortedSites.forEach((site) => {
    if (!site.border) return;

    try {
      const geoJSON = wkt.parse(site.border);

      // Handle Polygon only — skip other types
      if (!geoJSON || geoJSON.type !== "Polygon" || !geoJSON.coordinates?.[0]?.length) {
        console.warn(`Skipping site ID ${site.id} due to invalid geometry.`);
        return;
      }

      const latlngs = geoJSON.coordinates[0].map(coord => [coord[1], coord[0]]);
      const color = site.isTestSite ? "#1f7aaf" : "#ff8800";

      const polygon = leaflet.polygon(latlngs, {
        color,
        fillColor: color,
        weight: 2,
        fillOpacity: 0.2,
      });

      polygon.bindPopup(`<strong>${site.title} (${site.isTestSite ? "Lille-FiNN-område" : "Store-FiNN-område"})</strong>`);

      polygon.on("click", () => {
        polygon.openPopup();
        this.loadCollectionsForFinnSite(site.id);
      });

      polygon.addTo(this.map);

      // Add "F" label in center
      const latSum = latlngs.reduce((sum, coord) => sum + coord[0], 0);
      const lngSum = latlngs.reduce((sum, coord) => sum + coord[1], 0);
      const centerLat = latSum / latlngs.length;
      const centerLng = lngSum / latlngs.length;

      const icon = leaflet.divIcon({
        html: `<div style="font-weight: bold; font-size: 20px; color: ${color};">F</div>`,
        className: "",
        iconSize: [20, 20],
        iconAnchor: [10, 10],
      });

      leaflet.marker([centerLat, centerLng], { icon }).addTo(this.map);
    } catch (e) {
      console.warn(`Failed to parse WKT for site ID ${site.id}`, e);
    }
  });
},


async loadCollectionsForFinnSite(siteId) {
    try {
      if (this.collectionMarkersLayer) {
        this.map.removeLayer(this.collectionMarkersLayer);
      }

      const suffix = this.showLast30Days ? '/last30days' : '';
      const response = await axios.get(`/spontan/finn/sites/${siteId}/collections${suffix}`);
      const collections = response.data;

      const markers = collections
        .filter(col => col.latitude != null && col.longitude != null)
        .map(col => leaflet.circleMarker([col.latitude, col.longitude], {
          radius: 5,
          fillColor: "#1f7aaf",
          color: "#1f7aaf",
          weight: 1,
          opacity: 1,
          fillOpacity: 0.8,
        }));

      this.collectionMarkersLayer = leaflet.layerGroup(markers);
      this.collectionMarkersLayer.addTo(this.map);
    } catch (error) {
      console.error("Failed to load collections for site " + siteId, error);
    }
  },

  async getFinnSites() {
      this.finnSites = await finnSiteRepository.getFinnSites();
    },
      mapMoveend() {
        var mapBounds = this.map.getBounds().pad(0.5);
        const zoom = this.map.getZoom();
        const displayTooltipZoomLevel = 11;
        const tooltipOpacity = this.isMapColorFilled ? 0.75 : 0.4;
  
        if (zoom >= displayTooltipZoomLevel) {
          this.atlasSquarePolygonGroup.eachLayer((layer) => {
            if (mapBounds.contains(layer.getLatLngs())) {
              // Check if square layer has tooltip already
  
              if (!layer.getTooltip()) {
                let tooltipText;
                if (this.isMapShowingPoints) {
                  let point =
                    layer.atlasSquare.points != null
                      ? layer.atlasSquare.points
                      : 100;
                  tooltipText = "<b>Point: " + point + "</b>";
                } else {
                  if (
                    layer.atlasSquare.totalCounts != null &&
                    layer.atlasSquare.totalCounts > 0
                  ) {
                    let latest30DaysCounts = 0;
                    if (
                      layer.atlasSquare.totalCountsLatest30Days != null &&
                      layer.atlasSquare.totalCountsLatest30Days > 0
                    ) {
                      latest30DaysCounts =
                        layer.atlasSquare.totalCountsLatest30Days;
                    }
                    tooltipText = this.$englishPreferred
                      ? "Counts in total:<br><b>" +
                        layer.atlasSquare.totalCounts +
                        "</b></br>30 days:<br><b>" +
                        latest30DaysCounts +
                        "</b>"
                      : "Tællinger i alt:<br><b>" +
                        layer.atlasSquare.totalCounts +
                        "</b></br>Seneste måned:<br><b>" +
                        latest30DaysCounts +
                        "</b>";
                  } else {
                    tooltipText = this.$englishPreferred
                      ? "No counts"
                      : "Ingen tællinger";
                  }
                }
  
                layer
                  .bindTooltip(
                    "<div style='padding:1px 3px 1px 3px;color:white;background:#1f7aaf;'>" +
                      tooltipText +
                      "</div>",
                    {
                      className: "leaflet-tooltip-own",
                      direction: "center",
                      permanent: true,
                      opacity: tooltipOpacity,
                    }
                  )
                  .addTo(toRaw(this.map));
              }
            }
          });
        } else {
          this.atlasSquarePolygonGroup.eachLayer((layer) => {
            if (layer.getTooltip()) {
              layer.unbindTooltip();
            }
          });
        }
      },
      onMapClick(e) {
        this.setNewMarker(e.latlng.lat, e.latlng.lng);
      },
      getLocation() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.showPosition);
        } else {
          alert("Geolocation is not supported by this browser.");
        }
      },
      setNewRadiusCircle(lat, lng, radius) {
        this.clearRadiusCircle();
        this.radiusCircle = leaflet
          .circle([lat, lng], radius, { color: "#1f7aaf" })
          .addTo(toRaw(this.map));
      },
      clearRadiusCircle() {
        if (this.radiusCircle != undefined) {
          this.map.removeLayer(this.radiusCircle);
        }
      },
      showPosition(position) {
        this.clearGpsMarker();
        let accuracy = position.coords.accuracy;
        let latitude = position.coords.latitude;
        let longitude = position.coords.longitude;
        this.map.flyTo([latitude, longitude], 15);
        this.setNewRadiusCircle(latitude, longitude, accuracy);
        this.gpsMarker = leaflet
          .marker([latitude, longitude])
          .addTo(toRaw(this.map));
      },
      clearGpsMarker() {
        if (this.gpsMarker != null) {
          this.gpsMarker.remove();
        }
      },
    },
    async mounted() {
      if ($cookies.isKey("ortoPreferred")) {
        this.ortoPreferred = true;
      }
      this.atlasSquarePolygonGroup = leaflet.layerGroup();
      this.createMap();
      await this.getFinnSites(); // loads into this.finnSites
      this.drawFinnSitesOnMap(); // draw them
    },
  };
  </script>
  
  <style scoped>
  .center {
    position: absolute !important;
    top: 145px !important;
    left: 90% !important;
    transform: translate(-50%, -50%) !important;
    -webkit-transform: translate(-50%, -50%) !important;
  }

  .bottom-position-wrapper {
  position: fixed;
  bottom: 20px;
  left: 80%;
  transform: translateX(-50%);
  z-index: 1000;
}

.fixed-button {
  width: 40vw;
  min-width: 140px;
  max-width: 240px;
  padding: 10px 16px;
  font-size: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.toggle-wrapper {
  position: absolute;
  top: 200px; /* just below the info icon */
  left: 90%;
  transform: translate(-50%, -50%);
  z-index: 1001;
}
  </style>
  